import BasePreferences from '$/entities/lib/BasePreferences';
import { Preference }  from '$/entities/lib/BasePreferences';
import { Field }       from '$/entities/lib/JSONable';

export enum DraftLandlordEmailKeys {
	Draft = 'draft',		// LL: whether to receive draft invitation emails
}

/**
 * Landlord's email preferences. Keeps track of unsubscribes.
 */
export class DraftLandlordPreferences extends BasePreferences {

	@Field()
	emails: Partial<Record<DraftLandlordEmailKeys, Preference>> = {
		[DraftLandlordEmailKeys.Draft] : true,
	};

}
